import React, { FC } from 'react'
import { styled } from '@moonpig/launchpad-utils'
import { system as s } from '@moonpig/launchpad-system'
import { useExperiment } from '@moonpig/web-core-eppo/browser'
import { useProductsLocaleText } from '../../locale'

const StyledPriceSuffix = styled.p<{
  showInline: boolean
  color?: string
}>`
  ${({ showInline }) => showInline && 'margin-left: 4px; align-self: center;'}
  white-space: nowrap;
  ${({ color }) =>
    s({
      color: color ?? 'colorBlack70',
      typography: 'typeBodyCaption',
      mt: 2,
      mb: 0,
    })};
`

export const PriceSuffix: FC<{ inline?: boolean; color?: string }> = ({
  inline = false,
  color,
}) => {
  const localiseText = useProductsLocaleText()

  const isDripPricingEnabled =
    useExperiment('drip-pricing', {
      fallback: 'control',
    }) === 'variant'

  if (!isDripPricingEnabled) {
    return null
  }

  return (
    <StyledPriceSuffix
      showInline={inline}
      color={color}
      data-testid="product-price-suffix"
    >
      {localiseText('price.delivery')}
    </StyledPriceSuffix>
  )
}
